import { API } from "../../config/api/index";

//ALL TYPE WISE DATA RETURN
const initState = {
  settingData: {},
  defaultTaxInPercentage: null,
};

//DEFINE ACCOUNT REDUCER FUNCTION
const SettingReducer = (state = initState, action) => {
  switch (action.type) {
    case API.settings.get:
      return {
        ...state,
        settingData: action.settingData,
        defaultTaxInPercentage: action.defaultTaxInPercentage,
      };

    default:
      return state;
  }
};

//EXPORT ALL FUNCTION
export default SettingReducer;
